// APN Partner Central（ACE）枚举 + 公司 APN 用户
export const STAGES = [
  { value: 'Prospect', label: '潜在', color: '#64748b' },
  { value: 'Qualified', label: '已确认', color: '#2563eb' },
  { value: 'Technical Validation', label: '技术验证', color: '#7c3aed' },
  { value: 'Business Validation', label: '商务验证', color: '#c026d3' },
  { value: 'Committed', label: '已承诺', color: '#d97706' },
  { value: 'Launched', label: '已上线', color: '#059669' },
  { value: 'Closed Lost', label: '已丢单', color: '#9ca3af' },
]

export const REVIEW_STATUS = {
  'Pending Submission': { label: '待提交', cls: 'gray' },
  'Submitted': { label: '已提交', cls: 'info' },
  'In review': { label: 'AWS 审核中', cls: 'purple' },
  'Action Required': { label: '需补充', cls: 'orange' },
  'Approved': { label: '已批准', cls: 'green' },
  'Rejected': { label: '已拒绝', cls: 'critical' },
}

export const ORIGINS = {
  'Partner Referral': '伙伴发起',
  'AWS Referral': 'AWS 推荐',
}

export const INVITE_STATUS = {
  PENDING: { label: '待接受', cls: 'orange' },
  ACCEPTED: { label: '已接受', cls: 'green' },
  REJECTED: { label: '已拒绝', cls: 'gray' },
  EXPIRED: { label: '已过期', cls: 'gray' },
}

export const INDUSTRIES = [
  { value: 'Software and Internet', label: '软件与互联网' },
  { value: 'Gaming', label: '游戏' },
  { value: 'Retail', label: '零售电商' },
  { value: 'Financial Services', label: '金融服务' },
  { value: 'Healthcare', label: '医疗健康' },
  { value: 'Automotive', label: '汽车' },
  { value: 'Manufacturing', label: '制造' },
  { value: 'Media and Entertainment', label: '媒体娱乐' },
  { value: 'Education', label: '教育' },
  { value: 'Transportation and Logistics', label: '交通物流' },
  { value: 'Travel', label: '文旅' },
  { value: 'Life Sciences', label: '生命科学' },
  { value: 'Professional Services', label: '专业服务' },
  { value: 'Telecommunications', label: '电信' },
  { value: 'Energy - Power and Utilities', label: '能源' },
  { value: 'Other', label: '其他' },
]

export const USE_CASES = [
  'AI Machine Learning and Analytics',
  'Migration / Database Migration',
  'Containers & Serverless',
  'Storage & Backup',
  'Security & Compliance',
  'Networking',
  'Business Applications & Contact Center',
  'IoT',
]

export const DELIVERY_MODELS = ['Resell', 'Managed Services', 'Professional Services', 'SaaS or PaaS', 'BYOL or AMI', 'Other']

export const OPP_TYPES = [
  { value: 'Net New Business', label: '新业务' },
  { value: 'Expansion', label: '扩容' },
  { value: 'Flat Renewal', label: '续约' },
]

export const AWS_NEEDS = [
  'Co-Sell - Architectural Validation',
  'Co-Sell - Business Presentation',
  'Co-Sell - Competitive Information',
  'Co-Sell - Pricing Assistance',
  'Co-Sell - Technical Consultation',
  'Co-Sell - Total Cost of Ownership Evaluation',
  'Co-Sell - Deal Support',
  'Co-Sell - Support for Public Tender / RFx',
]

// Partner Central 用户（企业邮箱）；sales = 平台 tb_sales.name，用于自动带出 OpportunityTeam
export const APN_USERS = [
  { email: 'pay03@awscloud.vstecs.cn', name: '许业宝', first: '业宝', last: '许' },
  { email: 'pay07@awscloud.vstecs.cn', name: '蔡荣豪', first: '荣豪', last: '蔡' },
  { email: 'pay08@awscloud.vstecs.cn', name: '易浔', first: '浔', last: '易' },
  { email: 'pay09@awscloud.vstecs.cn', name: '孙立圆', first: '立圆', last: '孙', sales: '孙立圆' },
  { email: 'pay10@awscloud.vstecs.cn', name: 'xu yebao', first: 'yebao', last: 'xu' },
  { email: 'pay11@awscloud.vstecs.cn', name: 'sun fenglong', first: 'fenglong', last: 'sun' },
  { email: 'pay13@awscloud.vstecs.cn', name: 'miao jianrong', first: 'jianrong', last: 'miao' },
  { email: 'pay14@awscloud.vstecs.cn', name: 'yi xun', first: 'xun', last: 'yi' },
  { email: 'pay15@awscloud.vstecs.cn', name: 'cai ronghao', first: 'ronghao', last: 'cai' },
  { email: 'pay16@awscloud.vstecs.cn', name: 'rongsong li', first: 'rongsong', last: 'li', sales: '李荣松' },
  { email: 'pay17@awscloud.vstecs.cn', name: '南区-新销售', first: '新销售', last: '南区' },
  { email: 'pay18@awscloud.vstecs.cn', name: '李博扬', first: '博扬', last: '李', sales: '李博扬' },
  { email: 'pay19@awscloud.vstecs.cn', name: '姚菲菲', first: '菲菲', last: '姚', sales: '姚菲菲' },
  { email: 'pay20@awscloud.vstecs.cn', name: '赵婷婷', first: '婷婷', last: '赵' },
  { email: 'pay21@awscloud.vstecs.cn', name: '张银银', first: '银银', last: '张' },
  { email: 'pay22@awscloud.vstecs.cn', name: '李彬', first: '彬', last: '李' },
  { email: 'pay23@awscloud.vstecs.cn', name: '谭荣焜', first: '荣焜', last: '谭' },
]

export function apnUserOfSales(sales) {
  const u = APN_USERS.find(x => x.sales === sales)
  return u ? u.email : ''
}
